export default __webpack_public_path__ + "static/banner-renovation-ideas-d948d39626661f3d2ed378d3f66d1bf7.jpg";